import { useQuery } from "react-query";
import { z } from "zod";
import { ForwardType, InstrumentSchema } from "~/types";
import { agent } from "~/util/agent";

const ForwardsSchema = InstrumentSchema.extend({
  forward_type: z.nativeEnum(ForwardType),
});

type ForwardsResourceType = z.infer<typeof ForwardsSchema>;

const QUERY_FORWARDS_KEY = "forwards";

const useForward = (id: string) => {
  return useQuery([QUERY_FORWARDS_KEY, id], async () => agent(`instruments/forwards/${id}`).json<ForwardsResourceType>());
};

const useForwards = () => {
  return useQuery([QUERY_FORWARDS_KEY], async () => agent("instruments/forwards").json<ForwardsResourceType[]>());
};

export { useForward, useForwards };
